<template>
    <span>
        <div class="topFlo" v-if="!$store.state.kioskEvent.isConference"></div>
        <h1>{{ $store.state.kioskEvent.name }}</h1>
        <div class="mainImgWrap">
            <img v-bind:src="image" alt="">
        </div>
        <div class="actionsWrap kioskButtons">
            <router-link to="/guests/myPlace" class="myPlace">
                <img src="/static/images/myPlace.png" class="kioskNavIcon"/>
                <span>{{ $t('myPlace') }}</span>
            </router-link>
            <router-link to="/event/tables/preset" class="tableOrder" v-if="typeof $store.state.kioskEvent === 'object' && $store.state.kioskEvent.hasOwnProperty('isConference') && !$store.state.kioskEvent.isConference">
                <img src="/static/images/eventPreset.png" class="kioskNavIcon"/>
                <span>{{ $t('hallPreset') }}</span>
            </router-link>
        </div>
        <div class="bottomMenuWrap">
            <KioskLanguageSelector></KioskLanguageSelector>
            <AdminMenu v-on:openMenu="adminMenuOpened = true"></AdminMenu>
            <button class="adminEnt" @click.prevent="showArrivalStatus()">
                <Clock  />
            </button>
            <KioskArrivalStatus v-if="arrivalStatusOpened" v-on:close="arrivalStatusOpened = false"></KioskArrivalStatus>
        </div>
        <EventSelectModal @setEvent="setEvent" v-if="(!$store.state.kioskEvent.hasOwnProperty('id') && showSelectEvent) || $store.state.kioskEvent.hasOwnProperty('reset')"></EventSelectModal>
        <AdminMenu :modal="true" v-if="adminMenuOpened" v-on:closeMenu="closeMenu"></AdminMenu>
    </span>
</template>

<script>
    import Vue from 'vue'
    import KioskLanguageSelector from '../Kiosk/KioskLanguageSelector'
    import EventSelectModal from '../Modals/EventSelectModal'
    import AdminMenu from '../Modals/AdminMenu'
    import KioskArrivalStatus from './KioskArrivalStatus'
    import Clock from 'vue-digital-clock'

    export default {
        name: "KioskDashboard",
        components:{
            KioskLanguageSelector,
            EventSelectModal,
            AdminMenu,
            Clock,
            KioskArrivalStatus
        },
        data(){
            return {
                image:'/static/images/zug_2.jpg',
                clicksCounter:0,
                adminMenuOpened:false,
                showSelectEvent:false,
                arrivalStatusOpened:false
            }
        },
        beforeMount(){
            if(this.$store.state.isKiosk || this.$store.state.isTablet){
                this.axiosQueueManager()
            }
        },
        mounted(){
            window.setEvent = this.setEvent;
            $('body').addClass('kioskView')
            let _this = this;

            if (this.$store.state.isLogged) {
                this.getEvent()
            } else{
                setTimeout(function(){
                    if (_this.$store.state.isLogged) {
                        _this.getEvent()
                    }
                },1500);
            }

        },
        methods:{
            closeMenu(){
                this.adminMenuOpened = false;
            },
            setEvent(eventID){
                this.showSelectEvent = false;
                this.$store.state.kioskEvent = this.$store.state.closestEvents.find(event => event.id === eventID);
                if(this.$store.state.kioskEvent.hasOwnProperty("id")){
                    this.processKiosk();
                }else{
                    this.showSelectEvent = true;
                }
            },
            getEvent(){
                try{
                    window.seatupApp.loadPrintAssets();
                } catch(e){
                    console.log(`failed to fetch print logo - ${e.message}`)
                }
                if(!this.$store.state.kioskEvent.id) {
                    if (this.$store.state.user.type == 2) {
                        this.$store.dispatch('getEvents',true)
                            .then(response => {
                                //success
                                this.showSelectEvent = true;
                            })
                            .catch(err => {
                                //err
                                this.$store.dispatch('logoff')
                            })
                    } else {
                        this.$store.dispatch('logoff')
                    }
                }else{
                    this.processKiosk();
                }
            },
            showArrivalStatus(){
                this.arrivalStatusOpened = !this.arrivalStatusOpened;
                const _this = this;
                setTimeout(function(){ _this.arrivalStatusOpened = false },5000);
            },
            processKiosk(){
                let _this = this;
                this.$store.state.kioskEvent.gallery = Object.values(this.$store.state.kioskEvent.gallery)
                if(this.$store.state.kioskEvent.gallery.length){
                    this.image = '//app.seatup.co.il/kioskImages/' + this.$store.state.kioskEvent.gallery[0]
                    if(!window.imagesIterval || typeof window.imagesIterval ==='undefined'){
                        window.imagesIterval = setInterval(function(){

                            _this.positionGalleryItems()

                            let img = _this.$store.state.kioskEvent.gallery.filter(_=>{ return _this.image != '//app.seatup.co.il/kioskImages/' + _ }).pop();
                            if(typeof img !=='undefined' && img && img != ''){
                                $('.mainImgWrap img').animate({opacity:0},function(){
                                    _this.image = '//app.seatup.co.il/kioskImages/' + img;
                                    $('.mainImgWrap img').animate({opacity:1});
                                });
                            }
                        },10000);
                    }
                }
                this.$store.dispatch('getGuests',this.$store.state.kioskEvent.id)
                                        .then(response =>{
                                            //success
                                            this.$store.state.kioskEvent.guests = response.data;
                                        })
                                        .catch(err => {
                                            //err
                                            this.$store.dispatch('logoff')
                                        })
                if(!window.refreshInterval || typeof window.refreshInterval ==='undefined') this.axiosDataRefresh();
                this.kioskInteractiveChecker();
            },
            positionGalleryItems() {
                const [first, ...rest] = this.$store.state.kioskEvent.gallery;
                this.$store.state.kioskEvent.gallery = [...rest,first]
            },
            axiosDataRefresh(){
                let _this = this;
                //every second checks if had interaction in last 10 seconds
                window.refreshInterval = setInterval(function(){
                    window.liveIsBetter = true;
                    if(_this.$store.state.isLogged && _this.$store.state.kioskEvent.id && (_this.$store.state.lastInteraction+10 < (Math.floor(Date.now() / 1000)))){
                        _this.$store.state.lastInteraction = Math.floor(Date.now() / 1000);
                        _this.$store.dispatch('getEvent',_this.$store.state.kioskEvent.id)
                                                .then(response =>{
                                                    _this.$store.state.kioskEvent = Object.assign(response.data,{guests:[]});
                                                    //success
                                                    _this.$store.dispatch('getGuests',_this.$store.state.kioskEvent.id)
                                                        .then(response =>{
                                                            //success
                                                            _this.$store.state.kioskEvent.guests = response.data;
                                                        })
                                                })
                                                .catch(err => {
                                                    //err
                                                    console.warn('failed to auto refresh event');
                                                })
                    }
                },1000);
            },
            axiosQueueManager(){
                let _this = this;
                setInterval(function(){
                    if(_this.$store.state.axiosQueue.length > 0){
                        _this.$store.state.axiosQueue.forEach((request,id)=>{
                            switch(request.method){
                                case 'updateGuest':
                                    _this.$store.dispatch(request.method,request.data)
                                        .then(response =>{
                                            //success
                                            for(let guest in _this.$store.state.kioskEvent.guests){
                                                if(_this.$store.state.kioskEvent.guests[guest].id == response.id){
                                                    _this.$store.state.kioskEvent.guests[guest]= response;
                                                }
                                            }
                                            delete(_this.$store.state.axiosQueue[id])
                                        });
                                    break;

                            }
                        })
                    }
                },5000);
            },
            kioskInteractiveChecker(){
                let _this = this;
                setInterval(function () {
                    if (_this.$store.state.lastInteraction + (_this.$store.state.isTablet ? 19 : 9) < (Math.floor(Date.now() / 1000))) {
                        Vue.i18n.set('he');
                        _this.$store.dispatch('saveLang', 'he');
                        _this.$router.push('/');
                    }
                }, 1000);
            }
        }
    }
</script>
